<template>
  <div>
    <FilePopup
      v-if="isFilePriview"
      v-bind:filedata="filePriviewData"
      @closePopup="closePopup"
    ></FilePopup>
    <div class="w-full sm_star" v-if="!isFilePriview">
      <TopAppBarDrawer
        :isDrawerOpen="isDrawerOpen"
        @closeDrawer="closeDrawer"
      ></TopAppBarDrawer>
      <!-- <TopAppBar
      :leftBtnMode="leftBtnMode"
    :title="title"
    :leftBtnMethod="leftBtnMethod"
    :rightBtnMethod="rightBtnMethod"
    staticMode="true"
    >
    </TopAppBar> -->
      <div class="sm_header">
        <h1>{{ $t("S10037") }}</h1>
        <!-- <h1>S10037 </h1> -->

        <button class="menu_btn" @click="openDrawer()">
          <span>mobile menu</span>
        </button>
        <button class="search_btn" @click="searchOpen">
          <span>search</span>
        </button>
        <div class="search_box">
          <input
            type="text"
            :placeholder="$t('1452')"
            class="search_form"
            ref="search_form"
            @keyup="(e) => inputSearch(e)"
            v-model="contents"
          />
          <button type="button" class="search_close" @click="searchClose()">
            검색 닫기
          </button>
          <button type="button" class="search_btn" @click="search()">
            검색
          </button>
        </div>
      </div>

      <!-- content -->
      <div class="sm_wrap">
        <div
          class="mdc-tab-bar view-tab-bar abcd"
          role="tablist"
          id="learnViewTab"
          ref="learnViewTab"
          style="position: fixed; left: 0; top: 55px; z-index: 3; padding: none"
        >
          <div class="mdc-tab-scroller">
            <div
              class="mdc-tab-scroller__scroll-area mdc-tab-scroller__scroll-area--scroll mgb-000"
            >
              <div class="mdc-tab-scroller__scroll-content">
                <button
                  class="mdc-tab"
                  :class="{ 'mdc-tab--active': board.identifier == boardId }"
                  v-for="(board, i) in boards"
                  role="tab"
                  :tabindex="i"
                  @click="changeTabType(i, board.identifier)"
                  :key="board.id"
                >
                  <span class="mdc-tab__content">
                    <span class="mdc-tab__text-label">
                      {{ board.name }}
                    </span>
                  </span>
                  <!-- this.boardId :class="{'mdc-tab-indicator--active':(i==0)}"-->
                  <span
                    class="mdc-tab-indicator"
                    :class="{
                      'mdc-tab-indicator--active': board.identifier == boardId,
                    }"
                  >
                    <span
                      class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"
                    ></span>
                  </span>
                  <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                </button>

                <!-- <button class="mdc-tab mdc-tab--active" role="tab" tabindex="0" @click="changeTabType('ViewExam')">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('140')}}

                                </span>
                            </span>
                            <span class="mdc-tab-indicator mdc-tab-indicator--active ">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button>

                        <button class="mdc-tab" role="tab" tabindex="1" @click="changeTabType('ViewExam')">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label">
                                    {{$t('140')}}

                                </span>
                            </span>
                            <span class="mdc-tab-indicator">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                        </button> -->
              </div>
            </div>
          </div>
        </div>

        <div class="sm_list learning">
          <div class="user_fixed">
            <!-- userbox -->
            <div class="user_box" v-if="mamberData">
              <!-- <div class="user_img">
               <img v-if="mamberData.profile" :src="mamberData.profile" alt />
               <img v-else src="images/user.png" alt />
            </div>-->

              <div
                :style="
                  mamberData.profile
                    ? `background-image: url(${mamberData.profile});`
                    : `background-image: url('images/avatar_image.png');`
                "
                class="drawer-profile-logo user_img"
                @click="
                  priviewFiel({
                    contentType: 'image',
                    resourceUri: mamberData.profile
                      ? mamberData.profile
                      : 'images/avatar_image.png',
                  })
                "
              ></div>
              <router-link
                :to="'/ePromoter-mypost?bId=' + boardId"
                class="write_btn me"
              >
                <div class="user_txt">
                  <p class="name">
                    {{ mamberData.name ? mamberData.name.fullName : "" }}
                  </p>
                  <!-- <p class="date">{{ mamberData.storeName }} | {{ mamberData.responsibilityName }}</p> -->
                </div>
              </router-link>

              <div class="user_write">
                <router-link
                  :to="'/ePromoter-mypost?bId=' + boardId"
                  class="write_btn me"
                  v-if="selectedChild && selectedChild.register === true"
                >
                  {{ $t("1428") }}</router-link
                >
                <!-- :to="'/social-learning/write?board='+boardId" -->

                <a
                  class="write_btn"
                  @click="changeRoute"
                  v-if="selectedChild && selectedChild.register === true"
                  >{{ $t("1429") }}</a
                >
              </div>
            </div>
            <!-- //userbox -->
          </div>
          <!-- ppppppppppppppppppp like change by vue
{{ likeCount }} -->

          <div class="sm_list_box" v-if="listData1.length > 0">
            <!-- list-->
            <div
              class="list_box"
              v-for="(record, index) in listData1"
              :key="index"
            >
              <div @click="moveToDetail(record)">
                <!-- <div class="user_box">
                  <div class="user_img">
                    <img
                      v-if="record.auditor.register.profile"
                      :src="record.auditor.register.profile"
                    />
                    <img v-else src="images/user.png" alt />
                  </div>

                  <div class="user_txt">
                    <p class="name">
                      {{ record.auditor.register.name.fullName }}
                    </p>
                    <p class="date">
                      {{ record.auditor.register.storeName }} |
                      {{ record.auditor.register.responsibilityName }}
                    </p>
                    <p style="font-size: 12px">
                      {{
                        $moment(record.auditor.register.time).format(
                          "YYYY.MM.DD"
                        )
                      }}
                    </p>
                  </div> -->

                <!-- <div
                  class="user_date"
                >{{ $moment(record.auditor.register.time).format("YYYY.MM.DD") }}</div>-->
                <!-- </div> -->
                <!-- //userbox -->

                <div
                  class="user_con"
                  v-if="record.contents && record.contents.body !== ''"
                >
                  <span v-html="listFilter(record.contents.body)"></span>
                </div>

                <div
                  class="user_tag"
                  v-if="record.tags && record.tags.length > 0"
                >
                  <span v-for="(tag, i) in record.tags" :key="i"
                    >#{{ tag.name }}</span
                  >
                </div>
                <div
                  class="user_imgList"
                  v-if="record.contents.images.length > 2"
                >
                  <a href="#">
                    <img :src="record.contents.images[0].resourceUri" alt />
                  </a>
                  <a href="#">
                    <img
                      v-if="record.contents.images[1]"
                      :src="record.contents.images[1].resourceUri"
                      alt
                    />
                  </a>
                  <a href="#" class="more">
                    <img
                      v-if="record.contents.images[2]"
                      :src="record.contents.images[2].resourceUri"
                      alt
                    />
                    <span v-if="record.contents.images.length - 3 > 0"
                      >+{{ record.contents.images.length - 3 }}</span
                    >
                  </a>
                </div>

                <div
                  class="user_imgList"
                  v-if="record.contents.images.length == 2"
                >
                  <a
                    href="#"
                    v-for="(img, index1) in record.contents.images"
                    :key="index1"
                    style="width: 48%; height: 115px; padding-top: 32%"
                  >
                    <img :src="img.resourceUri" alt />
                  </a>
                </div>
                <div
                  class="user_imgList"
                  v-if="record.contents.images.length == 1"
                >
                  <a href="#" style="width: 100%; padding-top: 100%">
                    <img :src="record.contents.images[0].resourceUri" alt />
                  </a>
                </div>
              </div>

              <!-- Likes and Comments section -->
              <!-- <div class="user_opt">
                {{ $t("1430", { str: record.likesCount }) }} &nbsp;&nbsp;
                {{ $t("1431", { str: record.commentCount }) }}
                <span class="right">{{
                  $t("1432", { str: record.viewCount })
                }}</span>
              </div>

              <div class="list_btn">
                <a
                  @click="
                    patchLikeState(record.id, record.like, record);
                    record.like = !record.like;
                  "
                  class="like"
                  :class="{ on: record.like }"
                  >{{ $t("1433") }}</a
                >
                <a
                  href="javascript:void(0)"
                  @click="moveToDetail(record)"
                  class="reply"
                  >{{ $t("1434") }}</a
                >
              </div> -->
            </div>
          </div>
          <div v-if="nosearch" style="text-align: center; height: 100vh">
            <p style="font-size: 14px; color: #212121">{{ $t("1453") }}</p>
            <p style="padding: 2px 0 0 0; color: #818181; font-size: 14px">
              {{ $t("1454") }}
            </p>
          </div>

          <div
            class="sm_list_box"
            :class="listData1.length > 0 ? 'pdt-15' : ''"
          >
            <EPromoterNoData
              v-if="listData.length > 0 && listData[0].error"
            ></EPromoterNoData>

            <template v-if="listData.length > 0 && !listData[0].error">
              <!-- list-->
              <div
                class="list_box"
                v-for="(record, index) in listData"
                :key="index"
              >
                <div @click="moveToDetail(record)">
                  <div class="user_box">
                    <div class="user_img">
                      <img
                        v-if="record.auditor.register.profile"
                        :src="record.auditor.register.profile"
                      />
                      <img v-else src="images/user.png" alt />
                    </div>

                    <div class="user_txt">
                      <p class="name">
                        {{ record.auditor.register.name ? record.auditor.register.name.fullName : $t("S10082") }}
                      </p>
                      <p v-show="record.auditor.register.storeName" class="date">
                        {{ record.auditor.register.storeName }} |
                        {{ record.auditor.register.responsibilityName }}
                      </p>
                      <p style="font-size: 12px">
                        {{
                          $moment(record.auditor.register.time).format(
                            "YYYY.MM.DD"
                          )
                        }}
                      </p>
                    </div>

                    <!-- <div
                  class="user_date"
                >{{ $moment(record.auditor.register.time).format("YYYY.MM.DD") }}</div>-->
                  </div>
                  <!-- //userbox -->

                  <div
                    class="user_con"
                    v-if="record.contents && record.contents.body !== ''"
                  >
                    <span v-html="listFilter(record.contents.body)"></span>
                  </div>

                  <div
                    class="user_tag"
                    v-if="record.tags && record.tags.length > 0"
                  >
                    <span v-for="(tag, i) in record.tags" :key="i"
                      >#{{ tag.name }}</span
                    >
                  </div>
                  <div
                    class="user_imgList"
                    v-if="record.contents.images.length > 2"
                  >
                    <a href="#">
                      <img :src="record.contents.images[0].resourceUri" alt />
                    </a>
                    <a href="#">
                      <img
                        v-if="record.contents.images[1]"
                        :src="record.contents.images[1].resourceUri"
                        alt
                      />
                    </a>
                    <a href="#" class="more">
                      <img
                        v-if="record.contents.images[2]"
                        :src="record.contents.images[2].resourceUri"
                        alt
                      />
                      <span v-if="record.contents.images.length - 3 > 0"
                        >+{{ record.contents.images.length - 3 }}</span
                      >
                    </a>
                  </div>

                  <div
                    class="user_imgList"
                    v-if="record.contents.images.length == 2"
                  >
                    <a
                      href="#"
                      v-for="(img, index1) in record.contents.images"
                      :key="index1"
                      style="width: 48%; height: 115px; padding-top: 32%"
                    >
                      <img :src="img.resourceUri" alt />
                    </a>
                  </div>
                  <div
                    class="user_imgList"
                    v-if="record.contents.images.length == 1"
                  >
                    <a href="#" style="width: 100%; padding-top: 100%">
                      <img :src="record.contents.images[0].resourceUri" alt />
                    </a>
                  </div>
                </div>
                <!-- <div class="user_opt">
                  {{ $t("1430", { str: record.likesCount }) }} &nbsp;&nbsp;
                  {{ $t("1431", { str: record.commentCount }) }}
                  <span class="right">{{
                    $t("1432", { str: record.viewCount })
                  }}</span>
                </div>

                <div class="list_btn">
                  <a
                    @click="
                      patchLikeState(record.id, record.like, record);
                      record.like = !record.like;
                    "
                    class="like"
                    :class="{ on: record.like }"
                    >{{ $t("1433") }}</a
                  >
                  <a
                    href="javascript:void(0)"
                    @click="moveToDetail(record)"
                    class="reply"
                    >{{ $t("1434") }}</a
                  >
                </div> -->
              </div>
              <!-- //list-->
            </template>

            <infinite-loading
              @infinite="fetchData"
              :identifier="infiniteId"
              spinner="spiral"
              ref="infiniteLoading"
              v-if="boardId"
            >
              <div slot="no-more" class="mgt-16">No more data</div>
              <div slot="no-results" class="mgt-16"></div>
            </infinite-loading>
          </div>
        </div>
      </div>
      <!-- //content -->
    </div>
  </div>
</template>
<script>
/**
 * 나의 학습 목록 메인 컴포넌트(social learning list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import ePromoterApi from "@/api/ePromoterApi.js";
// import SocialLearningNoData from "./SocialLearningNoData.vue";
import EPromoterNoData from "./EPromoterNoData.vue";
import InfiniteLoading from "vue-infinite-loading";
//import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import FilePopup from "./FilePopup";
// Components/Mixin/Extend/API define
import { MDCTabBar, MDCTabBarFoundation } from "@material/tab-bar";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    EPromoterNoData,
    InfiniteLoading,
    //TopAppBar,
    TopAppBarDrawer,
    FilePopup,
  },
  computed: {
    ...mapState({
      likeCount: (state) => state.social.likeCount,
      viewCount: (state) => state.social.viewCount,
    }),
  },
  watch: {
    $route(to, from) {
      this.boardId=from.query.bId
      if (this.$route.query.a == 1) {
        this.fetBoardList();
        this.fetchMemberData();
        this.initData();
        this.getStaticData();
      }
    },

    likeCount(newLikeCount, oldLikeCount) {
      // Our fancy notification (2).
      //console.log(newLikeCount,`We have  on list page`)

      this.listData = this.listData.map((arr) => {
        if (newLikeCount.id == arr.id) {
          arr.likesCount = newLikeCount.likesCount;
          arr.like = newLikeCount.like;
        }
        return arr;
      });

      this.listData1 = this.listData1.map((arr) => {
        if (newLikeCount.id == arr.id) {
          arr.likesCount = newLikeCount.likesCount;
          arr.like = newLikeCount.like;
        }
        return arr;
      });
    },
    viewCount(newViewCount, oldViewCount) {
      this.listData = this.listData.map((arr) => {
        if (newViewCount.id == arr.id) {
          arr.viewCount = newViewCount.viewCount;
          arr.commentCount = newViewCount.commentCount;
        }
        return arr;
      });

      this.listData1 = this.listData1.map((arr) => {
        if (newViewCount.id == arr.id) {
          arr.viewCount = newViewCount.viewCount;
          arr.commentCount = newViewCount.commentCount;
        }
        return arr;
      });
    },
  },
  data: function () {
    return {
      nosearch: false,
      isDrawerOpen: false,
      mamberData: [],
      contents: "",
      status: "",
      isNoData: false,
      campaignData: null,
      listData: [],
      listData1: [],
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date(),
      filePriviewData: [],
      isFilePriview: false,
      selectedChild: null,
      boards: [],
      learnViewTab: null,
      boardId: null,
      boardData: null,
      myId: null,
    };
  },
  mixins: [topAppBarMixin],
  mounted() {
    this.fetBoardList();

    // let bid = this.$route.query.bId;
    // ePromoterApi
    //   .bordList({ bid })
    //   .then((response) => {
    //     this.boards = response.data.data.filter((arr) => arr.boardAuth == true);
    //     if (bid) {
    //       this.boardId = bid;
    //       let ti = this.boards.findIndex((arr) => arr.identifier == bid);
    //       //alert(ti)

    //       this.learnViewTab = new MDCTabBar(
    //         document.querySelector("#learnViewTab")
    //       );
    //       this.learnViewTab.activateTab(ti);
    //       this.changeTabType(0, this.boards[0].identifier); //for auto-activate first tab
    //     } else {
    //       this.boardId = this.boards[0].identifier;
    //     }

    //     console.log("this.boardId list page mounted", this.boardId);

    //     ePromoterApi
    //       .boardAuth(this.boardId)
    //       .then((response) => {
    //         this.boardData = response.data.data;
    //         // console.log('pravin kumar sahhhhh',this.boardData);
    //         this.fetchMemberData();
    //       })
    //       .catch((err) => {
    //         $state.error();
    //       });

    //     this.getStaticData();
    //     //console.log("board list data",response.data.data);
    //   })
    //   .catch((err) => {
    //     $state.error();
    //   });

    // this.setTopAppBarBackSearch(this.$t("S10037"));
  },
  // mounted() {
  //  // this.getStaticData()
  //   this.setTopAppBarBackSearch(this.$t("S100387"));
  // },

  methods: {
    fetBoardList() {
      let bid = this.$route.query.bId;
      ePromoterApi
        .bordList({ bid })
        .then((response) => {
          this.boards = response.data.data.filter(
            (arr) => arr.boardAuth == true
          );
          if (bid) {
            this.boardId = bid;
            let ti = this.boards.findIndex((arr) => arr.identifier == bid);
            //alert(ti)

            this.learnViewTab = new MDCTabBar(
              document.querySelector("#learnViewTab")
            );
            //console.log('dddddddddd',this.learnViewTab,ti)
            this.learnViewTab.activateTab(ti);
            this.changeTabType(0, this.boards[0].identifier); //for auto-activate first tab
          } else {
            this.boardId = this.boards[0].identifier;
          }

          ePromoterApi
            .boardAuth(this.boardId)
            .then((response) => {
              this.boardData = response.data.data;
              console.log("pravin kumar sahhhhh", this.boardData);
              ePromoterApi
                .fetchMember()
                .then((response) => {
                  this.mamberData = response.data.data;
                  let myId = this.mamberData.responsibilityId;
                  this.myId = myId;
                  //console.log('this.boards[0]',this.boards[0])
                  console.log("this.boards[0] ttttt", myId);
                  //this.boards[0].authPermission.forEach(permission => {
                  let permissionData = this.boardData.authPermission.find(
                    (child) => child.partId == myId
                  );
                  if (permissionData) {
                    this.selectedChild = permissionData;
                  }
                  //console.log('eeeeeeee',this.selectedChild)
                  // })
                })
                .catch((err) => {
                  $state.error();
                });
            })
            .catch((err) => {
              $state.error();
            });

          this.getStaticData();
          //console.log("board list data",response.data.data);
        })
        .catch((err) => {
          $state.error();
        });

      this.setTopAppBarBackSearch(this.$t("1427"));
    },

    fetchMemberData() {
      ePromoterApi
        .fetchMember()
        .then((response) => {
          this.mamberData = response.data.data;
          let myId = this.mamberData.responsibilityId;
          //console.log('this.boards[0]',this.boards[0])
          if (!this.boardData) {
            ePromoterApi
              .boardAuth(this.boardId)
              .then((response) => {
                this.boardData = response.data.data;
                let permissionData = this.boardData.authPermission.find(
                  (child) => child.partId == myId
                );
                if (permissionData) {
                  this.selectedChild = permissionData;
                }
                //console.log('pravin kumar sahhhhh',this.boardData);
              })
              .catch((err) => {
                $state.error();
              });
          }

          //this.boards[0].authPermission.forEach(permission => {
          let permissionData = this.boardData.authPermission.find(
            (child) => child.partId == myId
          );
          if (permissionData) {
            this.selectedChild = permissionData;
          }
          //console.log('eeeeeeee',this.selectedChild)
          // })
        })
        .catch((err) => {
          $state.error();
        });
    },

    changeRoute() {
      if (this.boardData.userBbsToDayAuth) {
        this.$router.push("/ePromoter-write?bId=" + this.boardId);
      } else {
        this.$alert({
          //title: this.$t('779'), //가입 승인 대기 상태입니다.
          content: this.$t("3064"),
          accept: this.$t("3065"),
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    getStaticData() {
      ePromoterApi
        .fetchStaticList(this.boardId)
        .then((response) => {
          this.listData1 = response.data.data;
          if(this.contents.length>0){
            this.listData1=[]
          }
        })
        .catch((err) => {
          $state.error();
        });
    },
    changeTabType(ti, boardId) {
      ePromoterApi
        .boardAuth(this.boardId)
        .then((response) => {
          this.boardData = response.data.data;
          let permissionData = this.boardData.authPermission.find(
            (child) => child.partId == this.myId
          );
          if (permissionData) {
            this.selectedChild = permissionData;
          }
          //console.log('pravin kumar sahhhhh',this.boardData);
        })
        .catch((err) => {
          $state.error();
        });

      // this.$router.push("/ePromoter?bId=" + boardId);

      this.boardId = boardId;
      this.initData();
      this.getStaticData();
      this.learnViewTab = new MDCTabBar(
        document.querySelector("#learnViewTab")
      );
      this.learnViewTab.activateTab(ti);
    },
    priviewFiel(file) {
      this.filePriviewData = file;
      this.isFilePriview = true;
      console.log("file priview data", this.filePriviewData);
    },
    closePopup() {
      this.filePriviewData = Array();
      this.isFilePriview = false;
    },
    listFilter(str) {
      let length = 120;
      let ending = " ...";
      let str1 = "";
      if (str.length > length) {
        str1 = str.substring(0, length - ending.length) + ending;
        return str1.replace(/(\r\n|\n|\r)/gm, "<br/>");
      } else {
        return str.replace(/(\r\n|\n|\r)/gm, "<br/>");
      }
    },
    // method to redirect the user on Detail page if exists
    moveToDetail(record) {
      if (record && record.id) {
        this.$router.push("/ePromoter/" + record.id + "?bId=" + this.boardId);
        // this.$router.push({
        //   name: "SLDetail",
        //   params: {
        //     postId: record.id
        //   }
        // });
      }
    },
    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },
    fetchData($state) {
      let responseData = null;
      let params = this.setParams();

      if (this.totalPages >= this.currentPage) {
        ePromoterApi
          .fetchList(params, this.boardId)
          .then((response) => {
            responseData = response.data.data;
            _.map(responseData.content, (o) => {
              o.progressViewStatus = false;
            });

            this.listData = this.listData.concat(responseData.content);
            this.currentPage++;
            this.totalPages = responseData.totalPages;

            if (responseData.content.length) {
              //let item = this.listData.find(item => item.auditor.register.id === this.mamberData.id);
              // print
              // let myId = this.mamberData.responsibilityId
              // this.listData[0].boardDto.authPermission.forEach(permission => {
              // let permissionData = permission.child.find(child => child.partId == myId)
              // if(permissionData) {
              // this.selectedChild = permissionData
              // }
              // })
            } else {
              this.listData = [{ error: true }];
              //this.listData = JSON.parse(JSON.stringify(this.listData))
            }

            if (responseData.content.length) {
              $state.loaded();
            } else {
              $state.complete();
            }

            if (this.listData.length > 0) {
              this.isNoData = false;
            } else {
              this.isNoData = true;
            }
          })
          .catch((err) => {
            $state.error();
          });
      } else {
        $state.complete();
      }
    },

    // 파라미터 설정(set parameter)
    setParams() {
      let params = {
        sort: "id,desc",
        contents: encodeURI(this.contents),
        page: this.currentPage,
      };
      return params;
    },
    // Open drawer
    openDrawer() {
      this.isDrawerOpen = true;
    },
    // Close drawer
    closeDrawer() {
      this.isDrawerOpen = false;
    },
    inputSearch(e) {
      if (e.keyCode == 13) {
        this.search();
      } else {
        $(".sm_star").addClass("backBg");
      }
    },
    searchOpen() {
      this.$nextTick(() => {
        this.$refs.search_form.focus();
      });
      $(".search_box").show();
      // $(".sm_star").addClass("backBg");
    },
    searchClose() {
      this.$router.go(this.$router.currentRoute);
      $(".user_fixed").show();
      $(".search_box").hide();
      $(".sm_star").removeClass("backBg");
      $(".sm_list.learning").css("padding-top", "90px");
    },
    search() {
      this.initData();
      this.listData1=[]
      // $(".search_box").hide();
      $(".sm_list.learning").css("padding-top", "15px");
      $(".user_fixed").hide();
      $(".learning").addClass("removeExtraPadding");
      $(".sm_star").removeClass("backBg");
      // let responseData = null;
      // let params = this.setParams();
      // ePromoterApi
      //   .fetchList(params)
      //   .then(response => {
      //     responseData = response.data.data;
      //     // _.map(responseData.content, (o) => {
      //     //   o.progressViewStatus = false;
      //     // });

      //     this.listData = responseData.content;
      //     this.listData1 = Array();
      //     if(this.listData.length < 1){
      //       this.nosearch = true;
      //     }else{
      //       this.nosearch = false;
      //     }

      //     //$(".search_box").hide();
      //     $(".sm_list.learning").css("padding-top", "15px");
      //     $('.user_fixed').hide();
      //     $(".sm_star").removeClass("backBg");
      //   })
      //   .catch(err => {
      //     $(".search_box").hide();
      //     $(".sm_star").removeClass("backBg");
      //     $state.error();
      //   });
    },
    patchLikeState(id, status, record) {
      this.$showLoading();
      let action = status
        ? ePromoterApi.patchPostLike(this.boardId, id)
        : ePromoterApi.patchPostDislike(this.boardId, id);

      action
        .then((response) => {
          record.likesCount = response.data.data.likesCount;
          this.$hideLoading();
          //this.detail.like = !status;
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
  },
};
</script>
<style scoped>
/* reset */
.sm_star * {
  margin: 0;
  /* padding: 0; */
  font-family: "Roboto", Arial, dotum, sans-serif;
  font-weight: normal;
  font-size: 13px;
  /* color: #222; */
  color: #818181;
}
ol,
ul,
li {
  list-style: none;
}
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
}
th {
  font-weight: normal;
}
form,
fieldset,
iframe {
  display: block;
  border: 0;
}
img,
button {
  border: none;
  vertical-align: middle;
}
hr {
  height: 0;
  display: none;
}
i,
em,
address {
  font-style: normal;
}
label,
button {
  cursor: pointer;
}
blockquote,
q {
  quotes: none;
}
caption,
.hide {
  visibility: hidden;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  font-size: 0;
  text-indent: -9999em;
}
legend {
  overflow: hidden;
  visibility: hidden;
  position: absolute;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  font-size: 0;
  text-indent: -100%;
  white-space: nowrap;
  z-index: -1;
}
input[type="text"],
input[type="password"],
input[type="email"],
input[type="search"],
input[type="image"],
input[type="tel"],
textarea {
  -webkit-appearance: none;
  -webkit-border-radius: 0;
}
input:focus {
  outline: none;
}
::-webkit-input-placeholder {
  color: #999;
}
::-moz-selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}
::-webkit-selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}
a {
  color: #222;
  text-decoration: none;
}
a:link,
a:visited {
  text-decoration: none;
}
button {
  display: inline-block;
  background: none;
  border: none;
  outline: none;
}
::selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}

/* header */
.sm_star {
  position: relative;
  margin: 0 auto;
}
.sm_star.backBg:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
}
.sm_header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 55px;
  border-bottom: 1px solid #e9e9e9;
  z-index: 4;
  background-color: #fff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
}
.sm_header h1 {
  text-align: center;
  color: #212121;
  font-size: 1.25rem;
  font-weight: 500;
  height: 55px;
  line-height: 55px;
}
.sm_header .menu_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
}
.sm_header .menu_btn span {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  font-size: 0;
  display: inline-block;
}
.sm_header .menu_btn:after {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: -5px;
}
.sm_header .menu_btn:before {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: 5px;
}
.sm_header .search_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url(/images/search_btn.svg) center center no-repeat;
  background-size: 22px auto;
}
.sm_header .search_btn span {
  font-size: 0;
  text-indent: -9999px;
}
.sm_header .back_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url(/images/back_btn.png) center center no-repeat;
  background-size: 22px auto;
  font-size: 0;
  text-indent: -9999px;
}
.sm_header .more_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url(/images/more_btn.png) center center no-repeat;
  background-size: 22px auto;
  font-size: 0;
  text-indent: -9999px;
}
.sm_header .more_box {
  position: absolute;
  right: 15px;
  top: 45px;
  width: 80px;
  z-index: 10;
}
.more_box {
  display: inline-block;
  padding: 15px 20px;
  background: #fff;
  box-shadow: 0 10px 13px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(206, 218, 220, 0.5);
  border-radius: 4px;
  display: none;
}
.more_box a {
  display: block;
  color: #333;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  text-align: left;
  margin-bottom: 5px;
}
.more_box a:nth-last-child(1) {
  margin-bottom: 0;
}

.search_box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 10;
  display: none;
}
.search_box .search_close {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url(/images/close_btn.svg) center center no-repeat;
  background-size: 22px auto;
  text-indent: -9999px;
}
.search_box .search_form {
  position: absolute;
  left: 60px;
  top: 12px;
  border: 0;
  background: #fff;
  font-size: 18px;
  color: #212121;
  height: 30px;
  width: calc(100% - 125px);
}

/* layer img */
.layer_img {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 999;
  overflow-x: hidden;
  overflow-y: auto;
  display: none;
}
.layer_img .layer_close {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  z-index: 999;
}
.layer_img .layer_close:before {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  display: inline-block;
  content: "";
  position: absolute;
  transform: rotate(-45deg);
  margin-top: -2px;
  top: 50%;
  left: 50%;
  margin-left: -9px;
}
.layer_img .layer_close:after {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  display: inline-block;
  content: "";
  position: absolute;
  transform: rotate(45deg);
  margin-top: -2px;
  top: 50%;
  left: 50%;
  margin-left: -9px;
}
.layer_img .img_placer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  white-space: nowrap;
  width: 100%;
}
.layer_img .img {
  display: inline-block;
  width: 100%;
  vertical-align: middle;
  text-align: center;
  white-space: normal;
  position: relative;
}
.layer_img .img_placer:after {
  display: inline-block;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  content: "";
}
.layer_img .img img {
  display: inline;
  max-width: 100%;
}

/* layer pop */
.layer_pop {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 999;
  display: none;
}
.layer_con {
  width: 90%;
  max-width: 300px;
  background: #fff;
  box-sizing: border-box;
  padding: 25px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  box-shadow: 0 19px 38px 0 rgba(0, 0, 0, 0.26);
}
.layer_con .layer_txt {
  font-size: 16px;
  color: #818181;
  line-height: 1.5;
}
.layer_con .layer_btn {
  position: relative;
  padding: 30px 0 0 0;
  text-align: right;
}
.layer_con .layer_btn a {
  display: inline-block;
  padding: 5px 15px;
  color: #2d6dcc;
  font-weight: 500;
  font-size: 14px;
  margin-left: 10px;
}

/* user */
.user_box {
  position: relative;
}
.user_box .user_img {
  position: relative;
  display: inline-block;
  border-radius: 50%;
  overflow: hidden;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  margin-right: 15px;
}
.user_box .user_img img {
  /* width: auto;
  height: auto; */
  min-width: 100%;
  min-height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.user_box .user_txt {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}
.user_box .user_txt .name {
  font-size: 14px;
  color: #212121;
}
.user_box .user_txt .date {
  position: relative;
  padding: 2px 0 0 0;
  color: #818181;
  font-size: 14px;
}
.user_box .user_write {
  position: absolute;
  right: 0;
  top: 0;
}
.user_box .user_write > a {
  display: inline-block;
  vertical-align: top;
  margin-left: 15px;
  background-size: 24px auto !important;
}
.user_box .user_write .write_btn {
  font-size: 12px;
  color: #acb4be;
  padding-top: 28px;
  background: url(/images/write_icon.png) center top no-repeat;
}
.user_box .user_write .write_btn.me {
  background: url(/images/my_write_icon.png) center top no-repeat;
}
.user_box .user_date {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 12px;
  color: #818181;
}
.user_fixed {
  position: fixed;
  left: 0;
  top: 103px;
  width: 100%;
  height: 75px;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  padding: 15px;
  z-index: 3;
}

/* style */
.sm_wrap {
  position: relative;
  padding: 55px 0 0 0;
}
.sm_list {
  position: relative;
}
.sm_list.view {
  padding-bottom: 85px;
}
.sm_list.learning {
  padding: 145px 15px 15px 15px;
  background: #f9f9f9;
  position: relative;
}
.sm_list_box {
  position: relative;
}
.sm_list_box > .list_box {
  position: relative;
  margin-bottom: 15px;
}
.sm_list_box > .list_box:nth-last-child(1) {
  margin-bottom: 0;
}
.sm_list .no_data {
  position: relative;
  height: calc(100vh - 210px);
  text-align: center;
  padding: 50px 0 0 0;
  min-height: 300px;
}
.sm_list .no_data .no_img img {
  max-width: 120px;
}
.sm_list .no_data p:nth-child(2) {
  position: relative;
  padding: 20px 0 0 0;
  font-size: 16px;
  font-weight: 500;
  color: #212121;
}
.sm_list .no_data p:nth-child(3) {
  position: relative;
  padding: 15px 0 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #818181;
  line-height: 1.57;
}
.sm_list.view .list_box {
  margin-bottom: 0;
}

.list_box {
  position: relative;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  padding: 15px;
}
.list_box .user_con {
  padding: 15px 0 0 0;
}
.list_box .user_tag {
  padding: 10px 0 0 0;
}
.list_box .user_opt {
  margin: 20px 0 0 0;
}
.list_box .user_imgList {
  margin: 20px 0 0 0;
  display: flex;
}
.user_con {
  position: relative;
  font-size: 14px;
  color: #818181;
  line-height: 1.57;
}
.user_con .em {
  color: #212121;
  margin-right: 5px;
  font-size: 14px;
}
.user_tag {
  position: relative;
  font-size: 0;
}
.user_tag span {
  display: inline-block;
  vertical-align: top;
  margin-right: 5px;
  font-size: 12px;
  color: #313d4b;
  padding: 2px 3px;
  background: #f4f5f6;
  border-radius: 2px;
}
.user_opt {
  position: relative;
  font-size: 12px;
  color: #818181;
}
.user_opt .right {
  position: absolute;
  right: 0;
  top: 0;
  color: #818181;
}
.list_btn {
  position: relative;
  text-align: center;
  font-size: 0;
  border-top: 1px solid #e6eced;
  margin: 15px 0 0 0;
  padding: 10px 0 0 0;
  display: flex;
  justify-content: space-evenly;
}
.list_btn a {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 10px 0 25px;
  background-size: 17px auto;
  background-position: left center;
  background-repeat: no-repeat;
  margin: 0 5px;
  color: #acb4be;
}
.list_btn a.like {
  background-image: url(/images/like_btn.png);
}
.list_btn a.like.on {
  background-image: url(/images/like_btn_on.png);
}
.list_btn a.reply {
  background-image: url(/images/reply_btn.png);
}
.list_btn a.share {
  background-image: url(/images/share_btn.png);
}
.user_imgList {
  position: relative;
  font-size: 0;
}
.user_imgList a {
  display: inline-block;
  position: relative;
}
.user_imgList a img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
}
.user_imgList a.more:before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
  z-index: 1;
}
.user_imgList a.more span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 18px;
  z-index: 2;
}
.user_imgList > a:nth-child(1) {
  width: 66%;
  height: 0;
  padding-top: 66%;
}
.user_imgList > a:nth-child(2) {
  width: 32%;
  height: 0;
  padding-top: 32%;
  position: absolute;
  right: 0;
  top: 0;
}
.user_imgList > a:nth-child(3) {
  width: 32%;
  height: 0;
  padding-top: 32%;
  position: absolute;
  right: 0;
  bottom: 0;
}
.user_imgList.view a {
  display: block;
  padding-top: 0;
  height: auto;
  position: relative;
  right: auto;
  top: auto;
  width: auto;
  margin-bottom: 10px;
}
.user_imgList.view a img {
  position: relative;
  left: 0;
  top: auto;
  width: auto;
  max-width: 100%;
  height: auto;
  transform: none;
}
.user_imgList.reply {
  margin: 0 0 0 55px;
  white-space: nowrap;
  overflow-x: auto;
}
.user_imgList.reply a {
  display: inline-block;
  width: 100px;
  height: 100px;
  padding-top: 0;
  position: relative;
  left: auto;
  top: auto;
  margin-right: 10px;
}
.user_imgList.reply a img {
}

.reply_wrap {
  position: relative;
  background: #f9f9f9;
  padding: 15px;
}
.reply_wrap > div:nth-last-child(1) {
  margin-bottom: 0;
}
.reply_box {
  position: relative;
  margin-bottom: 15px;
}
.reply_box .user_box .user_date {
  right: 40px;
  color: #a6a6a6;
}
.reply_box .user_box .more_btn {
  width: 22px;
  height: 22px;
  background: url(/images/reply_more_btn.png) center center no-repeat;
  background-size: 22px auto;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-indent: -9999px;
}
.reply_box .user_con {
  padding: 10px 15px 10px 58px;
}
.reply_box .list_btn {
  text-align: left;
  border-top: 0;
  margin: 0;
  padding: 0 0 0 55px;
}
.reply_box > .reply_box {
  padding: 10px 0 0 50px;
}

.comment_box {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 50;
  padding: 15px 15px 20px 15px;
  background: #fff;
  box-sizing: border-box;
  border-top: 1px solid #e6eced;
}
.comment_area {
  position: relative;
}
.comment_area button {
  display: inline-block;
  width: 50px;
  height: 50px;
  text-indent: -9999px;
  font-size: 0;
  position: absolute;
  top: 0;
  vertical-align: top;
}
.comment_area .picture_btn {
  background: url(/images/picture_btn.png) center center no-repeat;
  background-size: 22px auto;
  position: relative;
}
.comment_area .comment_btn {
  background: url(/images/comment_btn.png) center center no-repeat;
  background-size: 22px auto;
  right: 0;
}
.comment_area .comment_btn.on {
  background: url(/images/comment_btn_on.png) center center no-repeat;
  background-size: 22px auto;
}
.comment_textarea {
  position: relative;
  vertical-align: top;
  font-size: 14px;
  background: none;
  border: 0;
  width: calc(100% - 130px);
  resize: none;
  outline: none;
  height: 25px;
  margin-top: 14px;
}
.comment_area .tail_txt {
  position: absolute;
  right: 0;
  top: 15px;
  font-size: 14px;
  color: #acb4be;
}

.search_list {
  position: relative;
  background: #f9f9f9;
  padding: 15px;
  min-height: calc(100vh - 85px);
}
.search_list .no_data {
  position: relative;
  text-align: center;
  padding: 30px 0 0 0;
  min-height: 300px;
}
.search_list .no_data p:nth-child(1) {
  position: relative;
  font-size: 16px;
  font-weight: 500;
  color: #212121;
}
.search_list .no_data p:nth-child(2) {
  position: relative;
  padding: 15px 0 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #818181;
  line-height: 1.57;
}

.mdc-tab {
  text-transform: none !important;
}

.sm_list.learning.removeExtraPadding {
    margin-top: 45px !important;
}
</style>
